import React from "react";
import { Link } from "react-router-dom";
import { Icon } from "@/components/ui";
import Seo from "@/components/Seo";
import { ImmersiveShell } from "@/components/immersive/ImmersiveShell";
import { Reveal } from "@/components/immersive/Reveal";
import Breadcrumbs from "@/components/immersive/Breadcrumbs";
import { CtaCluster } from "@/components/immersive/MarketingBits";
import { SERVICES } from "@/lib/content";

const INTRO = "HomecareMatches helps families find home care services by connecting them with partner home-care agencies that may have available caregivers matching their needs and preferences. Explore the types of in-home care below, then get matched or book an appointment for guidance.";

export default function HomeCareServices() {
  return (
    <ImmersiveShell>
      <Seo title="Home Care Services" path="/home-care-services"
        description="Explore home care services and home care solutions — personal care, companion care, senior care, dementia support, respite, overnight and live-in care — through HomecareMatches partner agencies."
        keywords="home care services, home care solutions, in-home care, personal care, companion care, respite care, dementia care, overnight care, live-in care" />
      <section className="imm-mkt-hero imm-wrap" data-testid="home-care-services">
        <Breadcrumbs items={[{ label: "Home", to: "/" }, { label: "Home Care Services" }]} />
        <Reveal className="imm-eyebrow" delay={80}>Home care services</Reveal>
        <Reveal as="h1" delay={180}>Home Care Services</Reveal>
        <Reveal as="p" delay={320}>{INTRO}</Reveal>
      </section>

      <section className="imm-wrap" data-testid="services-list" style={{ paddingBottom: "6vh" }}>
        {SERVICES.map((s, i) => (
          <Reveal key={s.slug} delay={i * 45}>
            <div className="imm-feature" id={s.slug} data-testid={`service-${s.slug}`}>
              <span className="fnum"><Icon name={s.icon} size={22} /></span>
              <div>
                <h2 className="imm-svc-h2">{s.name}</h2>
                <p>{s.desc}</p>
                <p style={{ marginTop: 10 }}>
                  <Link className="imm-inline-link" to="/intake" data-testid={`svc-cta-${s.slug}`}>Get matched for {s.name.toLowerCase()} <Icon name="arrow-right" size={15} /></Link>
                </p>
              </div>
            </div>
          </Reveal>
        ))}
      </section>

      <section className="imm-wrap" data-testid="services-cta" style={{ paddingBottom: "8vh" }}>
        <Reveal as="h2" className="imm-svc-h2">Find the right home care services</Reveal>
        <Reveal delay={80}><div style={{ marginTop: 18 }}><CtaCluster showPromo /></div></Reveal>
      </section>
    </ImmersiveShell>
  );
}
